import React from 'react';
import PlansWorkspace from './PlansWorkspace';

const TestPlansPage = () => <PlansWorkspace />;

export default TestPlansPage;
